import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import placeImage from "../../images/placeholder.jpg";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";

export default function TransporterProductList() {
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [productList, setProductList] = useState([]);

    const logout = useLogout();

    const imageOnError = (event) => {
        event.currentTarget.src = placeImage;
    };

    const fetchProduct = useCallback(async () => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${config.apiUrl}/transporter/product`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.token,
                    Accept: "application/json",
                },
            });
            setProductList(response.data.list);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                logout();
            }
        } finally {
            setDataLoading(false);
        }
    }, [logout]);

    useEffect(() => {
        fetchProduct();
    }, [fetchProduct]);

    const handleProductChange = (index) => {
        if (index !== null) {
            const updateData = [...productList];
            updateData[index].is_selected = updateData[index].is_selected
                ? false
                : true;
            setProductList(updateData);
        }
    };

    const handleProductSubmit = async (e) => {
        e.preventDefault();

        const commodity_id = productList
            .filter((item) => item.is_selected)
            .map((item) => item.id);

        if (commodity_id.length > 0) {
            setLoading(true);
            try {
                const response = await axios.post(
                    `${config.apiUrl}/transporter/assign-product`,
                    { commodity_product: commodity_id },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: config.token,
                            Accept: "application/json",
                        },
                    }
                );
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                if (error.response && error.response.status === 401) {
                    logout();
                }
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Please select a product", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    return (
        <>
            {dataLoading ? (
                <div className="d-flex justify-content-center">
                    <Dataloader />
                </div>
            ) : (
                <>
                    {productList.length > 0 ? (
                        <form onSubmit={handleProductSubmit}>
                            <div className="row g-3">
                                {productList.map((product, index) => (
                                    <div className="col-lg-4 px-2" key={index}>
                                        <div className="order-product">
                                            <div className="row py-2 align-items-center">
                                                <div className="col-3">
                                                    <div
                                                        className="order-image"
                                                        style={{ height: "60px" }}
                                                    >
                                                        <img
                                                            src={product.thumbnail}
                                                            onError={imageOnError}
                                                            alt={product.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-9 ps-0">
                                                    <div className="order-detail">
                                                        <h6 className="one-line-clamp">{product.name}</h6>
                                                        <div className="order-tag">
                                                            <div>
                                                                <span className="f-500">Category:</span>
                                                                <span>{product.category_name}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="abs_check">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input custom_check"
                                                        type="checkbox"
                                                        checked={product.is_selected}
                                                        onChange={() => handleProductChange(index)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="col-lg-12 px-2 text-end">
                                    <button
                                        type="submit"
                                        title="Update Profile"
                                        className="submit_btn"
                                        disabled={loading}
                                    >
                                        <i className="bi bi-floppy"></i>
                                        {loading ? "Submitting" : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <NoData />
                    )}
                </>
            )}
        </>
    );
}
